import { HttpService } from '@Engage.Data.Services';
import { AppOptions } from '../../../application/options/AppOptions';
import { CookiesStorageService } from '@Engage.Data.Services';
import { StorageKeys } from '@Engage.Data/constants/Constants';
class ViewsRepositoryClass {
    /**
     * GET /api/views
     * SiteCode + ConfigCode sent via headers by HttpService automatically.
     * masterId and settingsKey sent as query params.
     */
    getViews() {
        const masterId = this.getUserId();
        const settingsKey = AppOptions.getSettingsKey();
        const params = {};
        if (masterId)
            params.masterId = masterId;
        if (settingsKey)
            params.settingsKey = settingsKey;
        return HttpService.get('views', params);
    }
    /**
     * POST /api/views
     * SiteCode + ConfigCode sent via headers by HttpService automatically.
     * UserId is required in the body.
     */
    postViews(payload) {
        return HttpService.post('views', payload);
    }
    getUserId() {
        var _a;
        return (_a = CookiesStorageService.get(StorageKeys.ConnextUserId, {
            expandKey: false,
            isSecureValue: false,
            useRootDomain: true
        })) !== null && _a !== void 0 ? _a : null;
    }
}
export const ViewsRepository = new ViewsRepositoryClass();
